import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const getStepsFieldsResponsesByRegistrationId = async (registrationId, eventId) => {
    return await vdkEmHappinessPortalApi.get(`/vdk-event-responses/get-steps-fields-responses-by-registration-id/${registrationId}/${eventId}`);
};
const getAllActiveResponsesByEventIdGroupedByRegistration = async (request) => {
    return await vdkEmHappinessPortalApi.post('/vdk-event-responses/get-all-active-responses-by-eventId-grouped-by-registration-id', request);
};
const getAllArchivedResponsesByEventIdGroupedByRegistration = async (request) => {
    return await vdkEmHappinessPortalApi.post('/vdk-event-responses/get-all-archived-responses-by-eventId-grouped-by-registration-id', request);
};
const getAllResponsesGridLabelsByEventId = async (eventId) => {
    return await vdkEmHappinessPortalApi.get(`/vdk-event-responses/get-all-responses-grid-labels-by-eventId/${eventId}`);
};
const getAllResponsesLabelsByEventId = async (eventId) => {
    return await vdkEmHappinessPortalApi.get(`/vdk-event-responses/get-all-responses-labels-by-eventId/${eventId}`);
};
const updateResponseGridLabels = async (request) => {
    return await vdkEmHappinessPortalApi.put('/vdk-event-responses/update-response-grid-labels', request);
};
const updateResponses = async (request) => {
    return await vdkEmHappinessPortalApi.put('/vdk-event-responses/update-responses', request);
};
const archiveResponses = async (request) => {
    return await vdkEmHappinessPortalApi.put('/vdk-event-responses/archive-responses', request);
};
const unarchiveResponses = async (request) => {
    return await vdkEmHappinessPortalApi.put('/vdk-event-responses/unarchive-responses', request);
};
const deleteResponses = async (request) => {
    return await vdkEmHappinessPortalApi.put('/vdk-event-responses/delete-responses', request);
};
const exportResponsesToExcel = async (eventId) => {
    return await vdkEmHappinessPortalApi.get(`/vdk-event-responses/export-responses-to-excel/${eventId}`);
};
const VDKEventResponseAPI = {
    getStepsFieldsResponsesByRegistrationId,
    getAllActiveResponsesByEventIdGroupedByRegistration,
    getAllArchivedResponsesByEventIdGroupedByRegistration,
    getAllResponsesGridLabelsByEventId,
    getAllResponsesLabelsByEventId,
    updateResponseGridLabels,
    updateResponses,
    archiveResponses,
    unarchiveResponses,
    deleteResponses,
    exportResponsesToExcel
};
export default VDKEventResponseAPI;
